var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifQueued(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 14.6667,
    height: 14.6667,
    viewBox: "0 0 14.6667 14.6667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.22167 0.256346C9.845 0.42114 10.4317 0.659176 10.9817 0.988764C11.5317 1.31835 12.045 1.70287 12.5033 2.16063C12.9617 2.61839 13.3467 3.13109 13.6767 3.6804C13.9883 4.22971 14.245 4.81565 14.41 5.4382C14.575 6.06076 14.6667 6.70162 14.6667 7.34249C14.6667 7.63546 14.6483 7.94673 14.6117 8.2397C14.6117 8.27632 14.5933 8.31294 14.5933 8.34956C14.5567 8.66084 14.4833 8.95381 14.41 9.22847C14.245 9.85102 13.9883 10.437 13.6767 10.9863C13.3467 11.5356 12.9617 12.0483 12.5033 12.506L10.8167 10.8215C11.5133 10.1257 11.9717 9.24678 12.1733 8.29463C12.3567 7.34249 12.265 6.33541 11.8983 5.4382C11.5317 4.54099 10.89 3.77195 10.0833 3.22264C9.27667 2.67333 8.305 2.39867 7.33333 2.39867V0C7.62667 0 7.92 0.0183104 8.23167 0.0549313C8.26833 0.0549313 8.32333 0.0732418 8.36 0.0732418C8.65333 0.109863 8.94667 0.183104 9.22167 0.256346Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83167 10.8215L2.145 12.506C2.60333 12.9638 3.09833 13.3483 3.66667 13.6779L4.85833 11.6088C4.47333 11.3891 4.125 11.1328 3.83167 10.8215Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.67333 12.2314C6.45333 12.1948 6.23333 12.1581 6.03167 12.1032L5.40833 14.4103C5.72 14.4836 6.03167 14.5568 6.34333 14.5934C6.67333 14.63 6.985 14.6484 7.29667 14.6667V12.2863C7.11333 12.268 6.89333 12.2497 6.67333 12.2314Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59833 12.1032C9.02 11.9933 9.42333 11.8285 9.79 11.6088L10.9817 13.6779C10.4317 13.9892 9.845 14.2455 9.22167 14.4103L8.59833 12.1032Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.54833 8.60591C2.65833 9.02705 2.82333 9.42988 3.04333 9.79609L0.971667 10.9863C0.66 10.437 0.403333 9.85102 0.238333 9.22847L2.54833 8.60591Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.85833 3.03953C5.225 2.81981 5.62833 2.65501 6.05 2.54515L5.42667 0.238036C4.80333 0.40283 4.21667 0.659176 3.66667 0.970454L4.85833 3.03953Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83167 3.82688C3.52 4.13816 3.26333 4.46775 3.04333 4.85227L0.971667 3.66209C1.30167 3.11278 1.68667 2.60008 2.145 2.14232L3.83167 3.82688Z",
    fill: "#0A3690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.055 6.37204C0.0916667 6.04245 0.165 5.73117 0.238333 5.4382L2.54833 6.04245C2.49333 6.24386 2.45667 6.46359 2.42 6.68331C2.38333 6.90304 2.38333 7.12276 2.38333 7.32418H0C0 7.0129 0.0183333 6.68331 0.055 6.37204Z",
    fill: "#0A3690"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifQueued);
export default __webpack_public_path__ + "static/media/notif-queued.337ea0f84ba5b26375579bc930fbb3dc.svg";
export { ForwardRef as ReactComponent };